import { required, email } from 'vuelidate/lib/validators'
import { fileSize } from '@/ic-common/helpers/validation'

export default {
  form: {
    email: {
      required,
      email
    },
    message: {
      required
    },
    name: {
      required
    },
    agreement: {
      required
    },
    files: {
      
      $each: {
        contact_fileSize: fileSize({ min: 0, max: 5000 })
      }
    }
  }
}
